import HomeSubNavigator from '@/views/home/HomeSubNavigator';
import { Container } from '@mui/material';
import { useEffect, useState } from 'react';
import useIsMobile from '../mobile/useInMobile';

interface CustomControlsProps {
  className?: string;
  getCurrentSlideIndex: () => number;
  onNext: () => void;
  onPrev: () => void;
  scrollToSlide: (index: number) => void;
  slidesCount: number;
  style?: React.CSSProperties;
  controlButtonProps: ButtonProp;
}

export interface ButtonProp {
  pageNumber: number;
  title: string;
  onSlideChange: (slideIndex: number) => void;
}

const activeNames = ['', '', '', '', '', 'data-infuser', 'data-verifier', 'doc-infuser', 'datamap', 'qufa-studio'];

export default function ControlButton(props: CustomControlsProps): JSX.Element {
  const {
    className = 'full-page-controls',
    getCurrentSlideIndex,
    onNext,
    onPrev,
    scrollToSlide,
    slidesCount,
    controlButtonProps,
  } = props;
  const isMobile = useIsMobile();

  const currentSlideIndex = getCurrentSlideIndex();
  useEffect(() => {
    controlButtonProps.onSlideChange(currentSlideIndex);
  });

  const displayStyle = isMobile || activeNames[currentSlideIndex] === '' ? 'none' : 'block';

  const handleOnClick = (slideIndex: number) => {
    scrollToSlide(slideIndex);
  };

  return (
    <Container maxWidth="xl" style={{ display: displayStyle }}>
      <HomeSubNavigator active={activeNames[currentSlideIndex]} moveSlide={handleOnClick} />
    </Container>
  );
}
